import { render, staticRenderFns } from "./Keys.vue?vue&type=template&id=04f4d484&scoped=true"
import script from "./Keys.vue?vue&type=script&lang=js"
export * from "./Keys.vue?vue&type=script&lang=js"
import style0 from "./Keys.vue?vue&type=style&index=0&id=04f4d484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f4d484",
  null
  
)

export default component.exports